import React from 'react'
import { Play, X } from 'lucide-react'
import styles from '../../_css/Simulation.module.css'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import useRole from '../../hooks/getRole'

const NewRunModal = ({ open, onClose, onConfirm, loading = false }) => {
  const role = useRole()
  const navigate = useNavigate()
  const context = useSelector((state) => state.context)
  const agencyId = useSelector((state) => state.user?.agencyId)
  if (!open) return null

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose?.()
  }

  const handleConfirm = async () => {
    await onConfirm?.()
    if(role === 'super_admin') {
      navigate(`/simulations?project_id=${context?.project_id}?brand_id=${context?.brand_id}?agency_id=${agencyId}`)
    } else {
      navigate(`/simulations?project_id=${context?.project_id}?brand_id=${context?.brand_id}`)
    }
  }

  return (
    <div
      className={styles.runsTabModalOverlay}
      onClick={handleOverlayClick}
      onKeyDown={() => {}}
      role="dialog"
      aria-modal="true"
    >
      <div className={styles.runsTabModalBox}>
        <div className={styles.runsTabModalHeader}>
          <h3 className={styles.runsTabModalTitle}>Start New Run</h3>
          <button
            type="button"
            onClick={onClose}
            className={styles.runsTabModalClose}
            aria-label="Close"
          >
            <X size={18} />
          </button>
        </div>
        <div className={styles.runsTabModalBody}>
          <p style={{ color: '#cbd5e1', margin: 0 }}>
            Do you want to start a new simulation run now?
          </p>
          <p
            style={{
              color: '#94a3b8',
              fontSize: 13,
              lineHeight: 1.5,
              margin: '12px 0 0',
            }}
          >
            This run will use the same saved setup as before—persona, queries, audience, and other
            simulation settings. It does not create a new configuration; it executes again with your
            existing data.
          </p>
          <div className={styles.runsTabModalActionsRow}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className={styles.runsTabRemoveScheduleBtn}
              style={{ opacity: loading ? 0.6 : 1 }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              disabled={loading}
              className={styles.runsTabSaveScheduleBtn}
              style={{ opacity: loading ? 0.6 : 1 }}
            >
              <Play size={14} />
              {loading ? 'Starting...' : 'Start Run'}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default NewRunModal